import "./BouncingDotsLoader.scss";

const BouncingDotsLoader = () => {
  return (
    <div className="bouncing-loader">
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default BouncingDotsLoader;
